import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import Spinner from "../Spinner";
import { Link } from "react-router-dom";
import { formatDate } from "../../Helper/Helper";

function TabsViewHomeNews() {
  const [portfolioItems, setPortfolioItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasData, setHasData] = useState(true);

  useEffect(() => {
    getPortfolioData();
  }, []);

  const getPortfolioData = async () => {
    try {
      const response = await SendPostRequest("news/list");

      if (!response?.data || response.data.length === 0) {
        setHasData(false);
        setLoading(false);
        return;
      }

      // Map the API data to our portfolio structure
      const mappedItems = response.data.map((item, index) => {
        const plainTextContent = item.content
          ? item.content.replace(/<[^>]*>/g, "")
          : "";

        return {
          id: item.id || index,
          title: item.title || "Name Of Work",
          category: item.category || "news",
          image: item.image || "images/portfolio/portfolio-motors/e1.jpg",
          content: plainTextContent
            ? plainTextContent.substring(0, 90) +
            (plainTextContent.length > 90 ? "..." : "")
            : "Excepteur sint occaecat cupidatat non proident, sunt in culpa officia deserunt mollit anim est laborum amet.",
          link: item.slug ? `/news/detail/${item.slug}` : "#",
          slug: item.slug || `news-${item.id || index}`,
          date: item.created_at ? formatDate(item.created_at) : "",
        };
      });

      setPortfolioItems(mappedItems);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching portfolio data:", error);
      setHasData(false);
      setLoading(false);
    }
  };

  if (!hasData) {
    return null;
  }

  return (
    <div
      id="news-section"
      className="portfolio-section py-5 section-bg-img bg-fixed my-5"
      data-bg=""
      style={{ backgroundImage: 'url("/assets/images/bg/features-bg.jpg")' }}
    >
      <div className="container-fulid">
        <div className="row">
          <div className="offset-md-2 col-md-8">
            <div className="title-wrap text-center">
              <div className="section-title margin-bottom-60">
                <h2 className="section-title margin-top-5 mb-0 text-uppercase">
                  Latest <span className="theme-color">News</span>
                </h2>
                <span className="section-border-bottom center"></span>
              </div>
            </div>
          </div>

          {/* News Items */}
          <div className="col-md-12">
            {loading ? (
              <div className="d-flex justify-content-center py-5">
                <Spinner />
              </div>
            ) : (
              <div
                className="row portfolio-wrap portfolio-classic-pro px-5"
                data-animation="fadeInDown"
              >
                {/* News Items Grid */}
                {portfolioItems?.length > 0 ? (
                  portfolioItems?.slice(0, 8)?.map((item) => (
                    <div
                      key={item?.id}
                      className="portfolio-item portfolio-overlay-wrap col-lg-3 col-md-3 col-sm-12 col-xs-12 animated fadeInUp visible"
                    >
                      <div className="portfolio-thumb tabs-home-news-portfolio-thumb relative">
                        <Link to={item?.link}>
                        <img
                          src={item?.image}
                          className="img-fluid"
                          alt={item?.title}
                        />
                        </Link>
                        <div className="portfolio-wrap mansory-services-mobile-view">
                          <div className="portfolio-details-overlay">
                            <h3 className="mb-2 typo-white tabs-home-news-portfolio-title">
                              <Link to={item?.link}>{item?.title}</Link>
                            </h3>
                            {item?.date && (
                              <small className="typo-white d-block mb-2">
                                {item?.date}
                              </small>
                            )}
                            <div className="portfolio-content tabs-home-news-portfolio-content w-75 typo-white">
                              {item?.content}
                            </div>
                          </div>
                          <div className="portfolio-icons">
                            <Link to={item?.link} className="link-icon">
                              <i className="icon-link"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="col-12 text-center py-5">
                    <p className="typo-white">No Record Available</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TabsViewHomeNews;
